var e = React.createElement;

export default class Menu extends React.Component {
    constructor(props) {
        super(props);
        this.dataI18nKeys = ["source-edit", "source-delete",
                                "source-saved-as-favorite", "source-save-as-favorite",
                                "source-this-data-is-true", "source-this-data-is-false"];
        this.applyTransalations = this.applyTransalations.bind(this);
    }
    
    applyTransalations(){
        for(var key in this.dataI18nKeys){
            globalFunctions.applyTranslatedMessage(this.dataI18nKeys[key],
                                "[data-i18n=" + this.dataI18nKeys[key] + "]");
        }
    }
    
    componentWillMount(){
        var isOwner = this.props.isOwner;
        var data = this.props.data;
    }
    
    componentDidMount(){
        this.applyTransalations();
    }
    
    componentDidUpdate(){
        this.applyTransalations();
    }

    render() {
        return (
                <div onContextMenu={(e) => e.stopPropagation()} onClick={(e) => e.stopPropagation()}
                 className={"toggle-block" + (this.props.topZero ? " top-zero" : "") 
                                        + (this.props.visible ? " show" : " hide")}>
                <div className="ui buttons dropdown-container">
                    <div className="ui floating dropdown icon button">
                        <i className="sidebar icon"></i>
                        <ul className="menu act-as-dropdown custom-font-size">
                            {this.props.items}        
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./frontend/web/js/Menu.js